import I18nActions from 'actions/I18nActions';
import { AA, Assets } from 'sdk';

class I18nActionCreator {
  fetch(locale, assetName) {
    I18nActions.fetchStarted({ locale, assetName });
    AA.asset(Assets.translations(locale, assetName)).then((response) => {
      I18nActions.fetchSucceeded({ locale, assetName, data: response.data });
    }, (error) => {
      I18nActions.fetchFailed({ locale, assetName, error });
    });
  }

  changeLocale(locale) {
    I18nActions.changeLocale(locale);
  }
}

export default new I18nActionCreator();
